/**
 * 全選択の存在するチェックボックスのチェック状態管理ができるHooks。
 */
import { useEffect, useState } from 'react';

const useCheckedItems = (items) => {
  const [checkedItems, setCheckedItems] = useState({});

  useEffect(() => {
    if (items) {
      setCheckedItems(items);
    }
  }, [items]);

  /**
   * 全選択
   */
  const checkAll = () => {
    setCheckedItems(
      Object.fromEntries(Object.entries(checkedItems).map((entry) => [entry[0], true]))
    );
  };

  /**
   * 全解除
   */
  const uncheckAll = () => {
    setCheckedItems(
      Object.fromEntries(Object.entries(checkedItems).map((entry) => [entry[0], false]))
    );
  };

  /**
   * itemKeyのものをチェック
   */
  const checkTargetItem = (itemKey) => {
    const checkedItemsCopy = { ...checkedItems };
    checkedItemsCopy[itemKey] = true;

    // 全選択チェックが存在する場合のみ
    if (checkedItems.isAllChecked !== undefined) {
      // isAllChecked以外で一つでもfalseがあればisAllCheckedもfalse
      checkedItemsCopy.isAllChecked = !Object.keys(checkedItemsCopy).some(
        (key) => key !== 'isAllChecked' && !checkedItemsCopy[key]
      );
    }
    setCheckedItems(checkedItemsCopy);
  };

  const uncheckTargetItem = (itemKey) => {
    const checkedItemsCopy = { ...checkedItems };
    checkedItemsCopy[itemKey] = false;
    // 全選択チェックが存在する場合のみ
    if (checkedItems.isAllChecked !== undefined) {
      checkedItemsCopy.isAllChecked = false;
    }
    setCheckedItems(checkedItemsCopy);
  };

  return [
    checkedItems,
    { setCheckedItems, checkAll, uncheckAll, checkTargetItem, uncheckTargetItem },
  ];
};

export default useCheckedItems;
